export default "__VITE_ASSET__CVTrR$DE__"